import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import { GAService } from '../../services/GAService';
import { MainLayout } from '../../components/layouts/MainLayout';
import { Container } from '../../uikit/grid';
export var UrbyoPage = function () {
    var gaEventMeta = useGAEventMeta();
    var audienceMarker = useAudienceMarker();
    var frameRef = useRef(null);
    var iframeSrc = useMemo(function () {
        var smavaAudienceParam = audienceMarker ? audienceMarker : 'none';
        return "https://p-urbyo-static.s3.eu-central-1.amazonaws.com/smava-baufi/index.html?smava_audience=".concat(smavaAudienceParam);
    }, [audienceMarker]);
    var handlePostmessage = useCallback(function (_a) {
        var data = _a.data;
        if (!!data && data.event === 'leadSubmitted') {
            GAService.onLeadCreated(undefined, gaEventMeta);
        }
        if (frameRef.current !== null &&
            !!data &&
            data.event === 'setScreenHeight' &&
            typeof data.screenHeight === 'number') {
            frameRef.current.style.height = "".concat(data.screenHeight, "px");
        }
    }, [gaEventMeta]);
    useEffect(function () {
        window.addEventListener('message', handlePostmessage);
        return function onUnmount() {
            window.removeEventListener('message', handlePostmessage);
        };
    }, []);
    return (React.createElement(MainLayout, { flatHeader: true },
        React.createElement(Container, { disableGutters: true },
            React.createElement("iframe", { ref: frameRef, src: iframeSrc, width: "100%", height: "1200px", scrolling: "no", frameBorder: "0" }))));
};
